import { Modal, Drawer } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import CustomBtn from "../../../../components/btn/CustomBtn";
import CustomSelect from "../../../../components/select/CustomSelect";
import CustomInput from "../../../../components/input/CustomInput";
import UploadImage from "../../../../components/upload/UploadImage";
import { useToast } from "../../../../components/toast";
import api from "../../../../api";
import CustomTextarea from "../../../../components/input/CustomTextarea";
import DynamicListInput from "../../../../components/input/DynamicListInput";

const CreateBundles = ({
  showModal,
  setShowModal,
  trigger,
  selectedData,
  setSelectedData,
}) => {
  const [classes, setClasses] = useState([]);
  const [allowedClassIds, setAllowedClassIds] = useState([]);
  const [saving, setSaving] = useState(false);
  const toast = useToast();

  // --- form ---
  const [program, setProgram] = useState(null); // "YOGA" | "MEGAFORMER"
  const [name, setName] = useState("");
  const [count, setCount] = useState(""); // credits (MF үед)
  const [price, setPrice] = useState("");
  const [description, setDescription] = useState("");
  const [coverImage, setCoverImage] = useState("");
  const [validDays, setValidDays] = useState("");

  const [includes, setIncludes] = useState([]);
  const [requirements, setRequirements] = useState([]);
  const [notices, setNotices] = useState([]);

  const programOptions = useMemo(
    () => [
      { value: "YOGA", label: "Yoga" },
      { value: "MEGAFORMER", label: "Megaformer" },
    ],
    [],
  );

  const kind = useMemo(
    () => (program === "MEGAFORMER" ? "COUNT" : program ? "UNLIMITED" : null),
    [program],
  );

  const resetForm = () => {
    setProgram(null);
    setName("");
    setCount("");
    setPrice("");
    setValidDays("");
    setDescription("");
    setCoverImage("");
    setAllowedClassIds([]);
    setSelectedData?.(null);
    setIncludes([]);
    setRequirements([]);
    setNotices([]);
  };

  const handleClose = () => {
    setShowModal(false);
    resetForm();
  };

  // Prefill when editing
  useEffect(() => {
    if (!showModal) return;
    (async () => {
      try {
        const res = await api.get_classes();
        setClasses(res?.data?.data || []);
      } catch (e) {
        toast("Class жагсаалт татах үед алдаа гарлаа.", "error");
      }
    })();
  }, [showModal]);

  useEffect(() => {
    if (!showModal) return;
    if (selectedData?.id) {
      // console.log("selectedData -0-->", selectedData);
      setProgram(selectedData.program || null);
      setName(selectedData.name || "");
      setPrice(selectedData.price != null ? String(selectedData.price) : "");
      setValidDays(
        selectedData.valid_days != null ? String(selectedData.valid_days) : "",
      );
      setDescription(selectedData.description || "");
      setCoverImage(selectedData.cover_image || "");
      setCount(
        selectedData.credits != null ? String(selectedData.credits) : "",
      );
      setAllowedClassIds(
        Array.isArray(selectedData.AllowedClasses)
          ? selectedData.AllowedClasses.map((c) => c.class_id)
          : [],
      );

      setIncludes(
        Array.isArray(selectedData.includes) ? selectedData.includes : [],
      );

      setRequirements(
        Array.isArray(selectedData.requirements)
          ? selectedData.requirements
          : [],
      );

      setNotices(
        Array.isArray(selectedData.notices) ? selectedData.notices : [],
      );
    } else {
      // шинэ бол clear
      resetForm();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModal, selectedData?.id]);

  const handleSave = async () => {
    if (!program || !name.trim()) {
      toast("Program болон багцын нэрийг бөглөнө үү.", "warning");
      return;
    }

    const numPrice = parseInt(String(price), 10);
    const numValidDays = parseInt(String(validDays), 10);
    const numCount = parseInt(String(count), 10);

    if (!Number.isFinite(numPrice) || numPrice <= 0) {
      toast("Үнэ зөв оруулна уу.", "warning");
      return;
    }
    if (!Number.isFinite(numValidDays) || numValidDays <= 0) {
      toast("Хүчинтэй хоногийг зөв оруулна уу.", "warning");
      return;
    }
    if (kind === "COUNT" && (!Number.isFinite(numCount) || numCount <= 0)) {
      toast("Megaformer багцын удааг (credits) зөв оруулна уу.", "warning");
      return;
    }

    // ⚠️ YOGA үед цаг эндээс авахгүй (restrict_time-ыг бид устгасан).
    // Checkout дээр AllowedClasses→Schedule-ээс distinct "HH:mm" харуулж, UserBundle.yoga_time-д хадгална.

    const payload = {
      name: name.trim(),
      valid_days: numValidDays,
      price: numPrice,
      description: description?.trim() || null,
      cover_image: coverImage || null,
      allowed_class_ids: allowedClassIds, // ⬅️ ШИНЭ: backend энэ массивыг авч BundleAllowedClass-д save хийнэ

      includes: includes.filter(Boolean),
      requirements: requirements.filter(Boolean),
      notices: notices.filter(Boolean),
    };

    if (!selectedData?.id) {
      payload.program = program; // program нэг сонгогдсоноос хойш edit-д өөрчлөхгүй
      if (kind === "COUNT") payload.credits = numCount;
      if (kind === "UNLIMITED") payload.credits = null;
    } else {
      // edit үед credits-ийг зөвхөн COUNT багц дээр л шинэчлэхийг зөвшөөрнө (хэрвээ бизнес зөвшөөрвөл)
      if (kind === "COUNT") payload.credits = numCount;
    }

    setSaving(true);
    try {
      let res;
      if (selectedData?.id) {
        res = await api.update_bundle(selectedData.id, payload);
      } else {
        res = await api.create_bundle(payload);
      }

      if (res.status === 200 || res.status === 201) {
        toast("Амжилттай", "success");
        handleClose();
        trigger?.();
      } else {
        toast(res?.data?.message || "Алдаа гарлаа", "error");
      }
    } catch (e) {
      toast("Хадгалах үед алдаа гарлаа.", "error");
    } finally {
      setSaving(false);
    }
  };

  return (
    // <Modal
    //   open={showModal}
    //   width={420}
    //   title={selectedData?.id ? "Багц засах" : "Багц нэмэх"}
    //   onCancel={handleClose}
    //   footer={
    //     <div className="d-flex gap-2 justify-content-end">
    //       <CustomBtn type="secondary" title="Болих" onClick={handleClose} />
    //       <CustomBtn
    //         title={"Хадгалах"}
    //         onClick={handleSave}
    //         disabled={saving}
    //         loading={saving}
    //       />
    //     </div>
    //   }
    // >
    <Drawer
      open={showModal}
      width={700}
      title={selectedData?.id ? "Багц засах" : "Багц нэмэх"}
      onClose={handleClose}
      destroyOnClose
      extra={
        <div className="d-flex gap-2">
          <CustomBtn type="secondary" title="Болих" onClick={handleClose} />
          <CustomBtn title="Хадгалах" onClick={handleSave} loading={saving} />
        </div>
      }
    >
      <div className="d-flex flex-column gap-2 py-3">
        <CustomSelect
          required
          title="Program"
          value={program}
          onChange={(v) => setProgram(v)}
          options={programOptions}
          showSearch
          disabled={!!selectedData?.id} // edit үед program солихгүй
        />

        <CustomInput
          required
          title="Багцын нэр"
          placeholder="-"
          value={name}
          onChange={(e) => setName(e?.target?.value)}
        />

        {program === "MEGAFORMER" && (
          <CustomInput
            required
            title="Хэдэн удаа орох (credits)"
            placeholder="-"
            type="number"
            value={count}
            onChange={(e) => setCount(e?.target?.value)}
          />
        )}

        {/* restrict_time бүр мөсөн хассан */}

        <CustomInput
          required
          title="Үнэ (₮)"
          placeholder="-"
          type="number"
          value={price}
          onChange={(e) => setPrice(e?.target?.value)}
        />

        <CustomInput
          required
          title="Хүчинтэй хоног"
          placeholder="-"
          type="number"
          value={validDays}
          onChange={(e) => setValidDays(e?.target?.value)}
        />

        <CustomTextarea
          title="Багцын тухай"
          placeholder="-"
          value={description}
          onChange={(e) => setDescription(e?.target?.value)}
        />

        <DynamicListInput
          title="Багцад багтсан зүйлс"
          value={includes}
          onChange={setIncludes}
          placeholder="Жишээ: 10 удаагийн хичээл"
        />

        <DynamicListInput
          title="Бэлдэх зүйлс"
          value={requirements}
          onChange={setRequirements}
          placeholder="Жишээ: Бэлтгэлийн хувцас."
        />

        <DynamicListInput
          title="Анхаарах зүйлс"
          value={notices}
          onChange={setNotices}
          placeholder="Жишээ: Цуцлах боломжгүй"
        />

        <UploadImage
          title={"Cover зураг"}
          value={coverImage}
          onUpload={(url) => setCoverImage(url)}
        />

        <CustomSelect
          required
          title="Холбох Class-ууд"
          options={classes.map((c) => ({
            value: c.id,
            label: `${c.title} (${c.program})`,
          }))}
          showSearch
          mode="tags"
          value={allowedClassIds}
          onChange={setAllowedClassIds}
        />
      </div>
    </Drawer>
    // </Modal>
  );
};

export default CreateBundles;
